import { FC } from 'react';
import { parseISO, format } from 'date-fns';
import Link from 'next/link';
import { IAuthorsPageData } from '@/interfaces/authorsPage.interface';
import { getAuthorFullName } from '@/helpers/helpers';
import styles from './AuthorsList.module.scss';

interface IAuthorsList {
  data: IAuthorsPageData[];
}

const AuthorsList: FC<IAuthorsList> = ({ data }) => {
  return (
    <ul className={styles.authorsList}>
      {data.map((author) => (
        <li key={author.id} className={styles.authorsList__item}>
          <Link prefetch={false} href={`/authors/${author.alias}`} className={styles.authorsList__name}>
            {getAuthorFullName(author.base_author_data.first_name, author.base_author_data.middle_name, author.base_author_data.last_name)}
          </Link>
          <div className={styles.authorsList__info}>
            <span className={styles.authorsList__date}>{author.updated_at ? format(parseISO(author.updated_at), 'dd.MM.yyyy') : '00.00.0000'}</span>
            <span className={styles.authorsList__count}>{author.books_count}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};
export default AuthorsList;
